export default __webpack_public_path__ + "static/media/partners.b3796913.svg";